module.exports = __webpack_public_path__ + "static/media/ccTanta.1a92e682.svg";